import { Identifiable, Unavailability } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeUnavailability(httpClient: HttpClient) {
  return (unavailability: Identifiable<Unavailability>) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/unavailabilities/${unavailability.uuid}`,
      method: HttpMethods.DELETE,
    });
}
export { removeUnavailability };
